import React from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";

function IntegrationsLayout() {
  return (
    <div className="bg-grey-100 flex gap-4 -ml-10 h-full overflow-auto">
      <Sidebar />
      <div className="overflow-auto w-full">
        <Outlet />
      </div>
    </div>
  );
}

export default IntegrationsLayout;
